import styled from 'styled-components';
import Colors from 'assets/Colors';

const Container = styled.div`
  width: 100%;
  background: ${Colors.background_secondary};
  border-radius: 6px;
  overflow: hidden;
  padding: 26px 20px 25px 19px;
  max-width: 100vw;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  margin-bottom: 29px;
`;

const Title = styled.div`
  background: ${Colors.BG_Header_Card};
  margin: -26px -20px -25px -19px;
  color: ${Colors.text_on_primary};
  display: flex;
  align-items: center;
  padding-left: 19px;
  height: 45px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.01em;
  margin-bottom: 41px;
`;

const InformationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @media (max-width: 550px) {
    flex-direction: column;
  }
  & > div {
    margin-bottom: 16px;
  }
`;

export default {
  Container,
  Title,
  InformationContainer,
};
